import { LogLevel } from "./log.target";

export abstract class LogTargetOptions {
  minLogLevel: LogLevel = 0;
}
